module.exports = __webpack_public_path__ + "img/img-intro1.dabae9bf.jpg";